<h2 mat-dialog-title> {{ practitioner?.name }} </h2>
<mat-dialog-content class="mat-typography">
        <mat-tab-group>
            <mat-tab label="Sobre">
               <page-data-person [person]="practitioner"></page-data-person>

               <page-map-view  [address]="address"></page-map-view> 
            </mat-tab>
            <mat-tab label="Dados Profissionais"> 
 
              <page-title title="Especialidades:"></page-title>
        
              <div class="info" >
                <div class="row" *ngFor="let specialty of  practitionerRole.specialtys">
                  <div >Especialidade: {{ specialty.value }}</div>
                  <div >CRM: {{ specialty.crm }}</div>
                  
                </div>
              </div>
              <page-qualifications
                [qualifications]="practitioner?.qualifications"
                [certificates]="practitioner?.certificates"
                [languages]="practitioner?.languages"
              ></page-qualifications>    
            </mat-tab>            
        </mat-tab-group>
        
</mat-dialog-content>
<mat-dialog-actions align="end">
  <div  class="toogle" >
    <mat-slide-toggle  [(ngModel)]="active" *ngIf="currentUser.type == 'organization'">Ativo</mat-slide-toggle>
  </div>
  
  <button mat-button  color="primary" [mat-dialog-close]="false">Fechar</button>
</mat-dialog-actions>




